/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Rule_Sets_Create_Show_In_SplitInputs */

const en_forms_rule_sets_create_show_in_split = /** @type {(inputs: Forms_Rule_Sets_Create_Show_In_SplitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show In Split`)
};

const de_forms_rule_sets_create_show_in_split = /** @type {(inputs: Forms_Rule_Sets_Create_Show_In_SplitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Im Split anzeigen`)
};

/**
* | output |
* | --- |
* | "Show In Split" |
*
* @param {Forms_Rule_Sets_Create_Show_In_SplitInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_rule_sets_create_show_in_split = /** @type {((inputs?: Forms_Rule_Sets_Create_Show_In_SplitInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Rule_Sets_Create_Show_In_SplitInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_rule_sets_create_show_in_split(inputs)
	return de_forms_rule_sets_create_show_in_split(inputs)
});